/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './site-assets.scss';

/* eslint-disable import/no-unresolved, import/default */

import siteAssetsTemplate from './site-assets.tpl.html';
import addSiteAssetTemplate from './../../admin/site/add-site-asset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.common.siteAssets', [])
    .directive('agSiteAssets', SiteAssets)
    .name;

/*@ngInject*/
function SiteAssets() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            hasParentAsset: '=',
            parentAssetId: '=',
            fetchAssets: '&',
            onAssetSelected: '&'
        },
        controller: SiteAssetsController,
        controllerAs: 'vm',
        templateUrl: siteAssetsTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function SiteAssetsController($rootScope, $scope, $document, $mdDialog, $q, $filter, $mdMedia,
                              $translate, agTypes, agUtils, userService, siteService, siloService, siloGroupService,
                              aerationService, weatherStationService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' ||
                  userService.getAuthority() === 'CUSTOMER_USER';
    vm.hasData = false;

    vm.siteAssets = [];
    vm.siteAssetsCount = 0;
    vm.allSiteAssets = [];
    vm.selectedSiteAssets = [];

    vm.isClientMode = true;
    vm.displayPagination = true;
    vm.mode = 'site';

    vm.currentSiteAsset = null;

    vm.query = {
        order: 'name',
        limit: 5,
        page: 1,
        search: null
    };

    vm.allowEditSettings = true;

    var user = userService.getCurrentUser();

    if (user.authority === 'CUSTOMER_USER') {
        var userAdditionalInfo = userService.getCurrentUserDetails().additionalInfo;
        if (userAdditionalInfo.readOnly) {
            vm.allowEditSettings = false;
        }
    }

    vm.addAssetAction = {
        name: 'ag.site.add-site-asset',
        show: true,
        onAction: function($event) {
            addAsset($event);
        },
        icon: 'add'
    };

    vm.multipleSettingsAction = {
        name: 'ag.asset.multi-settings',
        show: true,
        onAction: function($event) {
            navigateToMultiSettingsState($event);
        },
        icon: 'apps'
    };

    vm.searchAction = {
        name: 'action.search',
        show: true,
        onAction: function() {
            vm.enterFilterMode();
        },
        icon: 'search'
    };

    vm.refreshAction = {
        name: 'action.refresh',
        show: true,
        onAction: function() {
            vm.reloadSiteAssets();
        },
        icon: 'refresh'
    };

    vm.helpPageAction = agUtils.createHelpActionConfig("agGuiComponents", "ag.docsPageSections.assets-list-view");

    vm.onRowClick = onRowClick;
    vm.isCurrent = isCurrent;
    vm.enterFilterMode = enterFilterMode;
    vm.exitFilterMode = exitFilterMode;
    vm.onReorder = onReorder;
    vm.onPaginate = onPaginate;
    vm.copySiteAsset = copySiteAsset;
    vm.moveSiteAsset = moveSiteAsset;
    vm.gotoSiteAssetDetails = gotoSiteAssetDetails;
    vm.deleteSiteAsset = deleteSiteAsset;
    vm.deleteSiteAssets = deleteSiteAssets;
    vm.reloadSiteAssets = reloadSiteAssets;
    vm.updateSiteAssets = updateSiteAssets;
    vm.changeSelectedAssetType = changeSelectedAssetType;

    vm.siteAssetIcon = siteAssetIcon;
    vm.moveNameId = moveNameId;
    vm.detailsNameId = detailsNameId;
    vm.deleteNameId = deleteNameId;

    $scope.$watch(function() { return $mdMedia('gt-xs'); }, function(isGtXs) {
        vm.isGtXs = isGtXs;
    });

    $scope.$watch(function() { return $mdMedia('gt-md'); }, function(isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [5, 10, 15];
        } else {
            vm.limitOptions = null;
        }
    });

    $scope.$watch('vm.ctx', function() {
        if (vm.showData && vm.ctx) {
            vm.isEdit = vm.ctx.isEdit;
            if (vm.ctx.settings) {
                if (angular.isDefined(vm.ctx.settings.isClientMode)) {
                    vm.isClientMode = vm.ctx.settings.isClientMode;
                    if (vm.isClientMode && !vm.hasParentAsset) {
                        $scope.$watch(function() {
                                return vm.ctx.stateController.getStateId();
                            },
                            function (newStateId, prevStateId) {
                                if (newStateId && newStateId !== prevStateId) {
                                    if (newStateId == agTypes.clientState.site) {
                                        vm.currentSiteAsset = null;
                                    }
                                }
                            }
                        );
                    }
                }
                if (vm.hasParentAsset) {
                    vm.mode = 'site';
                    vm.ctx.widgetActions = [ vm.searchAction, vm.refreshAction, vm.helpPageAction ];
                } else {
                    vm.mode = angular.isDefined(vm.ctx.settings.mode) ? vm.ctx.settings.mode : 'site';
                    vm.ctx.widgetActions = [ vm.addAssetAction, vm.multipleSettingsAction, vm.searchAction, vm.refreshAction, vm.helpPageAction ];
                    vm.addAssetAction.show = !vm.isClientMode;
                    vm.multipleSettingsAction.show = vm.isClientMode && vm.mode != 'sites' && vm.allowEditSettings;
                    if (vm.mode == 'sites') {
                        vm.addAssetAction.name = 'ag.site.add';
                        vm.ctx.widgetTitle = $translate.instant('ag.site.sites') + '';
                    } else if (vm.mode == 'siloGroup') {
                        vm.addAssetAction.name = 'ag.silo-group.add-silo-group-asset';
                        vm.ctx.widgetTitle = $translate.instant('ag.silo-group.silo-group-assets') + '';
                    } else {
                        vm.ctx.widgetTitle = $translate.instant('ag.site.site-assets') + '';
                    }
                }
                vm.displayPagination = angular.isDefined(vm.ctx.settings.displayPagination) ? vm.ctx.settings.displayPagination : true;
            }
            vm.clientParentAssetId = null;
            if (vm.ctx.stateController) {
                if (vm.hasParentAsset) {
                    loadClientSiteAssets();
                    $scope.$watch('vm.parentAssetId', (newVal, prevVal) => {
                        if (newVal && !angular.equals(newVal, prevVal)) {
                            loadClientSiteAssets();
                        }
                    });
                } else if (vm.isClientMode) {
                    loadClientSiteAssets();
                    $scope.$watch(() => getClientParentAssetId(), (newVal, prevVal) => {
                        if (newVal && !angular.equals(newVal, prevVal)) {
                            loadClientSiteAssets();
                        }
                    });
                } else {
                    vm.clientParentAssetId = vm.ctx.stateController.getStateParams().entityId;
                    reloadSiteAssets(false, true);
                }
            }

        }
    });

    function getClientParentAssetId() {
        var targetStateId;
        var stateParams;
        if (vm.mode) {
            if (vm.mode == 'site') {
                targetStateId = agTypes.clientState.site;
            } else if (vm.mode == 'siloGroup') {
                targetStateId = agTypes.clientState.siloGroup;
            }
        }
        if (targetStateId) {
            stateParams = vm.ctx.stateController.getStateParamsByStateId(targetStateId);
        }
        if (stateParams) {
            return stateParams.entityId;
        } else {
            return null;
        }
    }

    function loadClientSiteAssets() {

        vm.clientParentAssetId = getClientParentAssetId();
        var currentSiteAssetId;
        if (vm.ctx.stateController.getStateId() != agTypes.clientState.site) {
            currentSiteAssetId = vm.ctx.stateController.getStateParams().entityId;
        }
        if (vm.mode == 'sites') {
            currentSiteAssetId = vm.clientParentAssetId;
        }
        reloadSiteAssets(false, true, currentSiteAssetId);
    }

    $scope.$on('editModeChanged', function() {
        vm.isEdit = vm.ctx.isEdit;
    });

    $scope.$watch("vm.query.search", function(newVal, prevVal) {
        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
            updateSiteAssets();
        }
    });

    $scope.$watch("vm.currentSiteAsset", function(newVal, prevVal) {
        if (!angular.equals(newVal, prevVal)) {
            var siteAssetId = vm.currentSiteAsset ? vm.currentSiteAsset.id : null;
            var siteAssetType = vm.currentSiteAsset ? vm.currentSiteAsset.type : null;
            $rootScope.$broadcast('siteAssetSelected', siteAssetId, siteAssetType);
        }
    });

    $scope.$on('siteAssetSelected', function(event, siteAssetId) {
        if (siteAssetId) {
            var result = $filter('filter')(vm.allSiteAssets, {id: { id: siteAssetId.id } }, true);
            if (result && result.length) {
                var newCurrentSiteAsset = result[0];
                vm.currentSiteAsset = newCurrentSiteAsset;
            }
        }
    });

    $scope.$on('siteAssetUpdated', function(event, siteAsset) {
        var result = $filter('filter')(vm.allSiteAssets, {id: { id: siteAsset.id.id } }, true);
        if (result && result.length) {
            var prevSiteAsset = result[0];
            var index = vm.allSiteAssets.indexOf(prevSiteAsset);
            vm.allSiteAssets[index].name = siteAsset.name;
            vm.allSiteAssets[index].label = siteAsset.label;
            if (siteAsset.type == agTypes.assetType.aeration) {
                vm.allSiteAssets[index].aerationType = (siteAsset.aerationType) ? siteAsset.aerationType : agTypes.aerationType.aeration;
            }
            index = vm.siteAssets.indexOf(prevSiteAsset);
            if (index > -1) {
                vm.siteAssets[index].name = siteAsset.name;
                vm.siteAssets[index].label = siteAsset.label;
                if (siteAsset.type == agTypes.assetType.aeration) {
                    vm.siteAssets[index].aerationType = (siteAsset.aerationType) ? siteAsset.aerationType : agTypes.aerationType.aeration;
                }
            }
        }
    });

    $scope.$watch(() => vm.ctx.stateController.getStateId(), (newVal, prevVal) => {
        vm.multipleSettingsAction.show = (vm.isClientMode && vm.mode != 'sites' && vm.allowEditSettings && (newVal == agTypes.clientState.site || newVal == agTypes.clientState.siloGroup));
        vm.multiSettingsMode = (newVal == agTypes.clientState.siloGroupMultiSettings || newVal == agTypes.clientState.multiSettings);
        vm.ctx.hideTitlePanel = !!vm.multiSettingsMode;
        if (newVal == agTypes.clientState.siloGroup && prevVal == agTypes.clientState.siloGroupMultiSettings) {
            vm.selectedSiteAssets = [];
            vm.selectedAssetType = null;
            reloadSiteAssets();
        }
        if (newVal == agTypes.clientState.siloGroupMultiSettings && prevVal == agTypes.clientState.siloGroup) {
            vm.cashedSiteAssets = angular.copy(vm.siteAssets);
            vm.siteAssets = [];
            computeCurrentAssetTypes();
        }
    });

    $scope.$watch('vm.selectedSiteAssets.length', function (newLength) {
        var selectionMode = newLength ? true : false;
        if (vm.ctx) {
            if (selectionMode) {
                vm.ctx.hideTitlePanel = true;
            } else if (vm.query.search == null) {
                vm.ctx.hideTitlePanel = false;
            }
            if (vm.multiSettingsMode) {
                vm.ctx.hideTitlePanel = true;
                var selectedAssetsInfo = {};
                selectedAssetsInfo.selectedAssetType = vm.selectedAssetType;
                selectedAssetsInfo.selectedAssets = vm.selectedSiteAssets;
                $rootScope.$broadcast('multiSettingsSelectedAssets', selectedAssetsInfo);
            }
        }
    });

    $scope.$on('siteAssetCopied', function() {
        reloadSiteAssets(true);
    });

    $scope.$on('siteAssetMoved', function() {
        reloadSiteAssets();
    });

    $scope.$on('alarmsUpdated', function() {
        reloadSiteAssets(true);
    });

    function onRowClick($event, siteAsset) {
        if ($event) {
            $event.stopPropagation();
        }
        if (vm.multiSettingsMode) {
            return;
        }
        if (vm.currentSiteAsset != siteAsset) {
            vm.currentSiteAsset = siteAsset;
        }
        if (vm.isClientMode && vm.onAssetSelected) {
            vm.onAssetSelected({asset: siteAsset});
        } else {
            vm.ctx.stateController.openRightLayout();
        }
    }

    function isCurrent(siteAsset) {
        return (vm.currentSiteAsset && siteAsset) &&
            (vm.currentSiteAsset.id.id === siteAsset.id.id);
    }

    function enterFilterMode () {
        vm.query.search = '';
        vm.ctx.hideTitlePanel = true;
    }

    function exitFilterMode () {
        vm.query.search = null;
        updateSiteAssets();
        vm.ctx.hideTitlePanel = false;
    }

    function onReorder () {
        updateSiteAssets();
    }

    function onPaginate () {
        updateSiteAssets();
    }

    function addAsset($event) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: AddAssetController,
            controllerAs: 'vm',
            templateUrl: addSiteAssetTemplate,
            parent: angular.element($document[0].body),
            locals: {
                mode: vm.mode,
                parentAssetId: vm.clientParentAssetId
            },
            fullscreen: true,
            targetEvent: $event
        }).then(function () {
            reloadSiteAssets();
        }, function () {
        });
    }

    function copySiteAsset($event, siteAsset) {
        var copyDialogPromise;
        if (siteAsset.type === agTypes.assetType.silo) {
            copyDialogPromise = siloService.copySiloDialog($event, siteAsset);
        } else if (siteAsset.type === agTypes.assetType.weatherStation) {
            copyDialogPromise = weatherStationService.copyWeatherStationDialog($event, siteAsset);
        }
        if (copyDialogPromise) {
            copyDialogPromise.then(
                function() {
                    reloadSiteAssets();
                }
            );
        }
    }

    function moveSiteAsset($event, siteAsset) {
        var moveDialogPromise;
        if (siteAsset.type === agTypes.assetType.silo) {
            moveDialogPromise = siloService.moveSiloDialog($event, siteAsset, vm.clientParentAssetId);
        } else if (siteAsset.type === agTypes.assetType.siloGroup) {
            moveDialogPromise = siloGroupService.moveSiloGroupDialog($event, siteAsset, vm.clientParentAssetId);
        } else if (siteAsset.type === agTypes.assetType.aeration) {
            moveDialogPromise = aerationService.moveAerationDialog($event, siteAsset, vm.clientParentAssetId);
        } else if (siteAsset.type === agTypes.assetType.weatherStation) {
            moveDialogPromise = weatherStationService.moveWeatherStationDialog($event, siteAsset, vm.clientParentAssetId);
        }
        if (moveDialogPromise) {
            moveDialogPromise.then(
                function() {
                    reloadSiteAssets();
                }
            );
        }
    }

    function gotoSiteAssetDetails($event, siteAsset) {
        if ($event) {
            $event.stopPropagation();
        }
        var params = {
            entityId: siteAsset.id
        };
        var targetState;
        if (siteAsset.type === agTypes.assetType.silo) {
            targetState = agTypes.adminState.silo;
        } else if (siteAsset.type === agTypes.assetType.siloGroup) {
            targetState = agTypes.adminState.siloGroup;
        } else if (siteAsset.type === agTypes.assetType.aeration) {
            targetState = agTypes.adminState.aeration;
        } else if (siteAsset.type === agTypes.assetType.weatherStation) {
            targetState = agTypes.adminState.weatherStation;
        }
        if (targetState) {
            vm.ctx.stateController.openState(targetState, params);
        }
    }

    function getSiteAssetDeletePromise(siteAsset) {
        var deletePromise;
        if (siteAsset.type === agTypes.assetType.silo) {
            deletePromise = siloService.deleteSilo(siteAsset.id);
        } else if (siteAsset.type === agTypes.assetType.siloGroup) {
            deletePromise = siloGroupService.deleteSiloGroup(siteAsset.id);
        } else if (siteAsset.type === agTypes.assetType.aeration) {
            deletePromise = aerationService.deleteAeration(siteAsset.id);
        } else if (siteAsset.type === agTypes.assetType.weatherStation) {
            deletePromise = weatherStationService.deleteWeatherStation(siteAsset.id);
        }
        return deletePromise;
    }

    function deleteSiteAsset($event, siteAsset) {
        if ($event) {
            $event.stopPropagation();
        }
        if (siteAsset) {
            var name = siteAsset.name;
            var title;
            var content;
            if (siteAsset.type === agTypes.assetType.silo) {
                title = $translate.instant('ag.silo.delete-silo-title', {siloName: name});
                content = $translate.instant('ag.silo.delete-silo-text');
            } else if (siteAsset.type === agTypes.assetType.siloGroup) {
                title = $translate.instant('ag.silo-group.delete-silo-group-title', {siloGroupName: name});
                content = $translate.instant('ag.silo-group.delete-silo-group-text');
            } else if (siteAsset.type === agTypes.assetType.aeration) {
                title = $translate.instant('ag.aeration.delete-aeration-title', {aerationName: name});
                content = $translate.instant('ag.aeration.delete-aeration-text');
            } else if (siteAsset.type === agTypes.assetType.weatherStation) {
                title = $translate.instant('ag.weather-station.delete-weather-station-title', {weatherStationName: name});
                content = $translate.instant('ag.weather-station.delete-weather-station-text');
            }
            var confirm = $mdDialog.confirm()
                .targetEvent($event)
                .title(title)
                .htmlContent(content)
                .ariaLabel(title)
                .cancel($translate.instant('action.no'))
                .ok($translate.instant('action.yes'));
            $mdDialog.show(confirm).then(function () {
                var promise = getSiteAssetDeletePromise(siteAsset);
                if (promise) {
                    promise.then(
                        function success() {
                            reloadSiteAssets();
                        }
                    );
                }
            });
        }
    }

    function deleteSiteAssets($event) {
        if ($event) {
            $event.stopPropagation();
        }
        if (vm.selectedSiteAssets && vm.selectedSiteAssets.length > 0) {
            var title = $translate.instant('ag.site.delete-site-assets-title', {count: vm.selectedSiteAssets.length}, 'messageformat');
            var content = $translate.instant('ag.site.delete-site-assets-text');
            var confirm = $mdDialog.confirm()
                .targetEvent($event)
                .title(title)
                .htmlContent(content)
                .ariaLabel(title)
                .cancel($translate.instant('action.no'))
                .ok($translate.instant('action.yes'));
            $mdDialog.show(confirm).then(function () {
                var tasks = [];
                for (var i=0;i<vm.selectedSiteAssets.length;i++) {
                    var siteAsset = vm.selectedSiteAssets[i];
                    var promise = getSiteAssetDeletePromise(siteAsset);
                    if (promise) {
                        tasks.push(promise);
                    }
                }
                $q.all(tasks).then(function () {
                    reloadSiteAssets();
                });

            });
        }
    }

    function reloadSiteAssets (keepSelection, skipNotify, currentSiteAssetId) {
        vm.allSiteAssets.length = 0;
        vm.siteAssets.length = 0;
        if (!keepSelection) {
            vm.currentSiteAsset = null;
        }
        if (vm.multiSettingsMode) {
            vm.currentAssetTypes = [];
        }
        vm.siteAssetsPromise = null;
        if (vm.hasParentAsset) {
            vm.siteAssetsPromise = vm.fetchAssets({fetchAlarmsSeverity: vm.isClientMode});
        } else if (vm.mode === 'sites' || vm.clientParentAssetId || vm.hasParentAsset) {
            if (vm.mode === 'sites') {
                vm.siteAssetsPromise = siteService.getCustomerSites(vm.isClientMode);
            } else if (vm.mode === 'site') {
                vm.siteAssetsPromise = siteService.getSiteAssets(vm.clientParentAssetId, vm.isClientMode, agTypes.assetBrowserWidgetType.list);
            } else if (vm.mode === 'siloGroup') {
                vm.siteAssetsPromise = siloGroupService.getSiloGroupAssets(vm.clientParentAssetId, vm.isClientMode, agTypes.assetBrowserWidgetType.list);
            }
        }
        if (vm.siteAssetsPromise) {
            vm.siteAssetsPromise.then(
                function success(allSiteAssets) {
                    vm.allSiteAssets = allSiteAssets;
                    vm.selectedSiteAssets = [];
                    vm.updateSiteAssets(currentSiteAssetId);
                    if (vm.multiSettingsMode) {
                        vm.cashedSiteAssets = angular.copy(vm.siteAssets);
                        vm.siteAssets = [];
                        computeCurrentAssetTypes();
                    }
                    vm.siteAssetsPromise = null;
                },
                function fail() {
                    vm.allSiteAssets = [];
                    vm.selectedSiteAssets = [];
                    vm.updateSiteAssets();
                    vm.siteAssetsPromise = null;
                }
            )
        } else {
            vm.allSiteAssets = [];
            vm.selectedSiteAssets = [];
            vm.updateSiteAssets();
        }
        if (!skipNotify) {
            $rootScope.$broadcast('siteAssetsListUpdated', vm.clientParentAssetId, keepSelection);
        }
    }

    function updateSiteAssets (currentSiteAssetId) {
        vm.selectedSiteAssets = [];
        var result = $filter('orderBy')(vm.allSiteAssets, vm.query.order);
        if (vm.query.search != null) {
            result = $filter('filter')(result, {$: vm.query.search});
        }
        vm.siteAssetsCount = result.length;

        if (vm.displayPagination) {
            var startIndex = vm.query.limit * (vm.query.page - 1);
            vm.siteAssets = result.slice(startIndex, startIndex + vm.query.limit);
        } else {
            vm.siteAssets = result;
        }

        if (currentSiteAssetId) {
            result = $filter('filter')(vm.siteAssets, {id: { id: currentSiteAssetId.id } }, true);
            if (result && result.length) {
               vm.currentSiteAsset = result[0];
            }
        }
    }

    function navigateToMultiSettingsState($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var params = angular.copy(vm.ctx.stateController.getStateParams());
        if (params) {
            params.tableMode = vm.mode;
            if (vm.mode === 'site') {
                vm.ctx.stateController.openState(agTypes.clientState.multiSettings, params, true);
            } else if (vm.mode === 'siloGroup') {
                vm.ctx.stateController.openState(agTypes.clientState.siloGroupMultiSettings, params, true);
            }
        }
    }

    function siteAssetIcon(siteAsset) {
        return (siteAsset.type === agTypes.assetType.aeration && siteAsset.aerationType)
            ? agUtils.getAssetIcon(siteAsset.aerationType, siteAsset.highestAlarmSeverity, siteAsset.highestAlarmStatus)
            : agUtils.getAssetIcon(siteAsset.type, siteAsset.highestAlarmSeverity, siteAsset.highestAlarmStatus);
    }

    function moveNameId (assetType) {
        if (assetType === agTypes.assetType.silo) {
            return 'ag.silo.move';
        } else if (assetType === agTypes.assetType.siloGroup) {
            return 'ag.silo-group.move';
        } else if (assetType === agTypes.assetType.aeration) {
            return 'ag.aeration.move';
        } else if (assetType === agTypes.assetType.weatherStation) {
            return 'ag.weather-station.move';
        }
    }

    function detailsNameId (assetType) {
        if (assetType === agTypes.assetType.silo) {
            return 'ag.silo.details';
        } else if (assetType === agTypes.assetType.siloGroup) {
            return 'ag.silo-group.details';
        } else if (assetType === agTypes.assetType.aeration) {
            return 'ag.aeration.details';
        } else if (assetType === agTypes.assetType.weatherStation) {
            return 'ag.weather-station.details';
        }
    }

    function deleteNameId (assetType) {
        if (assetType === agTypes.assetType.silo) {
            return 'ag.silo.delete';
        } else if (assetType === agTypes.assetType.siloGroup) {
            return 'ag.silo-group.delete';
        } else if (assetType === agTypes.assetType.aeration) {
            return 'ag.aeration.delete';
        } else if (assetType === agTypes.assetType.weatherStation) {
            return 'ag.weather-station.delete';
        }
    }

    function computeCurrentAssetTypes() {
        vm.currentAssetTypes = [];
        for (var i = 0; i < vm.cashedSiteAssets.length; i++) {
            var found = vm.currentAssetTypes.find((element) => {
               return element.type ===  vm.cashedSiteAssets[i].type;
            });
            if (!found) {
                vm.currentAssetTypes.push(vm.cashedSiteAssets[i]);
            }
        }
    }

    function changeSelectedAssetType() {
        vm.siteAssets = [];
        vm.selectedSiteAssets = [];
        for (var i = 0; i < vm.cashedSiteAssets.length; i++) {
            if (vm.cashedSiteAssets[i].type === vm.selectedAssetType) {
                vm.siteAssets.push(vm.cashedSiteAssets[i]);
            }
        }
    }
}

/*@ngInject*/
function AddAssetController($scope, $mdDialog, types, agTypes, entityRelationService, siloService, siloGroupService, aerationService, weatherStationService, mode, parentAssetId) {

    var vm = this;

    vm.mode = mode;
    vm.parentAssetId = parentAssetId;

    vm.asset = {
        id: {
            entityType: types.entityType.asset
        },
        positionX: 0.5,
        positionY: 0.5
    };

    vm.agTypes = agTypes;
    if (mode === 'site') {
        vm.assetTypes = [agTypes.assetType.silo, agTypes.assetType.siloGroup, agTypes.assetType.aeration, agTypes.assetType.weatherStation];
    } else if (mode === 'siloGroup') {
        vm.assetTypes = [agTypes.assetType.silo, agTypes.assetType.aeration, agTypes.assetType.weatherStation];
    }


    vm.add = add;
    vm.cancel = cancel;

    $scope.$watch('vm.asset.type', function(newType) {
        if (newType && newType === agTypes.assetType.silo) {
            vm.asset[agTypes.attributes.silo.maxTelemetryDelaySec] = agTypes.defaults.silo.maxTelemetryDelaySec;
            vm.asset[agTypes.attributes.silo.maxTemperature] = agTypes.defaults.silo.maxTemperature;
            vm.asset[agTypes.attributes.silo.maxDeltaTemperature] = agTypes.defaults.silo.maxDeltaTemperature;
            vm.asset[agTypes.attributes.silo.maxMoisture] = agTypes.defaults.silo.maxMoisture;
            vm.asset[agTypes.attributes.silo.maxDeltaMoisture] = agTypes.defaults.silo.maxDeltaMoisture;
            vm.asset[agTypes.attributes.silo.maxCO2] = agTypes.defaults.silo.maxCO2;
            vm.asset[agTypes.attributes.silo.maxDeltaCO2] = agTypes.defaults.silo.maxDeltaCO2;
            vm.asset[agTypes.attributes.silo.maxHeadSpaceTemperatureThreshold] = agTypes.defaults.silo.maxHeadSpaceTemperatureThreshold;
            vm.asset[agTypes.attributes.silo.maxHeadSpaceHumidityThreshold] = agTypes.defaults.silo.maxHeadSpaceHumidityThreshold;
            vm.asset[agTypes.attributes.silo.maxHeadSpaceCo2CriticalThreshold] = agTypes.defaults.silo.maxHeadSpaceCo2CriticalThreshold;
            vm.asset[agTypes.attributes.silo.maxHeadSpaceCo2WarningThreshold] = agTypes.defaults.silo.maxHeadSpaceCo2WarningThreshold;
            vm.asset[agTypes.attributes.silo.minHeadSpaceDewpointTemperatureDiffThreshold] = agTypes.defaults.silo.minHeadSpaceDewpointTemperatureDiffThreshold;
        } else if (newType && newType === agTypes.assetType.siloGroup) {
            vm.asset[agTypes.attributes.siloGroup.maxTelemetryDelaySec] = agTypes.defaults.siloGroup.maxTelemetryDelaySec;
        } else if (newType && newType === agTypes.assetType.weatherStation) {
            vm.asset[agTypes.attributes.weatherStation.maxTelemetryDelaySec] = agTypes.defaults.weatherStation.maxTelemetryDelaySec;
        }
    });

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        var type = vm.asset.type;
        var saveAssetPromise;
        if (type) {
            if (type === agTypes.assetType.siloGroup) {
                saveAssetPromise = siloGroupService.saveSiloGroup(vm.asset, vm.parentAssetId);
            } else if (type === agTypes.assetType.silo) {
                saveAssetPromise = siloService.saveSilo(vm.asset, vm.parentAssetId);
            } else if (type === agTypes.assetType.aeration) {
                saveAssetPromise = aerationService.saveAeration(vm.asset, vm.parentAssetId);
            } else if (type === agTypes.assetType.weatherStation) {
                saveAssetPromise = weatherStationService.saveWeatherStation(vm.asset, vm.parentAssetId);
            }
        }
        if (saveAssetPromise) {
            saveAssetPromise.then(function success(asset) {
                if (type === agTypes.assetType.aeration) {
                    let newRelation = {
                        from: {id: vm.asset.gatewayDeviceId, entityType: types.entityType.device},
                        to: asset.id,
                        type: types.entityRelationType.contains
                    };
                    entityRelationService.saveRelation(newRelation).then(
                        () => {
                            vm.asset = asset;
                            $scope.theForm.$setPristine();
                            $mdDialog.hide();
                        }
                    );
                } else {
                    vm.asset = asset;
                    $scope.theForm.$setPristine();
                    $mdDialog.hide();
                }
            });
        }
    }
}